import React from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as SorryBuddy } from '../../../../../assets/icons/buddy-sorry.svg';
import { BreadcrumbItemProps } from '../../../../../shared/components/Breadcrumbs/BreadcrumbItem/BreadcrumbItem';
import GenericPageNE from '../../../../../shared/components/GenericPageNE/GenericPageNE';
import { TRANSLATION_POINTS_CONFIG } from '../../../../../shared/translations/rewards';
import { GenericVoidFunction } from '../../../../../shared/types/genericTypes';

interface PointsConfigErrorProps {
  breadcrumbs: BreadcrumbItemProps[];
  retry: GenericVoidFunction;
  cancel: GenericVoidFunction;
}

const PointsConfigError = ({ breadcrumbs, retry, cancel }: PointsConfigErrorProps) => {
  const { t } = useTranslation();

  return (
    <GenericPageNE
      breadcrumbs={breadcrumbs}
      ImageComponent={SorryBuddy}
      title={t(TRANSLATION_POINTS_CONFIG.error.title)}
      description={t(TRANSLATION_POINTS_CONFIG.error.description)}
      primaryButton={{
        text: t(TRANSLATION_POINTS_CONFIG.error.primaryButton),
        action: retry
      }}
      secondaryButton={{
        text: t(TRANSLATION_POINTS_CONFIG.error.secondaryButton),
        action: cancel
      }}
    />
  );
};

export default PointsConfigError;
